import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { useEffect, useState } from "react";
import { ActionType } from "@common/build/types";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import DropdownInput from "../../../ActionDropdown";
import { getSlideoutTargets } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { useTranslation } from "react-i18next";

const SlideOut = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const slideouts = useAppSelector(getSlideoutTargets);
    const dispatch = useAppDispatch();
    const [selectedSlideout, setSelectedSlideout] = useState<string>(actionStep?.action?.target || "");
    const { t } = useTranslation();

    useEffect(() => {
        if (selectedSlideout) {
            const action = { type: ActionType.TOGGLE_SLIDEOUT, target: selectedSlideout };
            const updatedStep = {
                ...actionStep,
                title: `${t("Open Slide out")}: ${(typeof selectedSlideout === "string" && slideouts[selectedSlideout]) || ""}`,
                noTranslate: true
            };
            updatedStep.action = { ...action };
            if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
                dispatch(updateStepperActions({ id: id, item: updatedStep as ActionEditorItem }));
            }
        }
    }, [selectedSlideout, actionStep, dispatch, id, t, slideouts]);

    return (
        <div className="page-wrapper">
            <DropdownInput
                title="Select slide out element"
                layout="column"
                value={selectedSlideout}
                callback={setSelectedSlideout}
                options={slideouts}
                noTranslate
            />
        </div>
    );
};

export default SlideOut;
